export default __webpack_public_path__ + "static/media/expertise_m.be95f476.jpg";